import { loadData as searchPageLoadData } from '../SearchPage/SearchPage.duck';
import { resolveSeoSlug, buildSeoSearchParams, buildSeoCanonicalPath } from '../../util/seoLandingPages';

/**
 * loadData for the /sewa-:seoSlug route. Resolves the slug (deterministic
 * lookup against src/config/seo/*, no string-guessing) into the same kind
 * of { pub_categoryLevel2|3, pub_product_loction } params the regular /s
 * search page already knows how to consume, and delegates straight to
 * SearchPage's own, unmodified loadData with those params serialized as a
 * synthetic query string — so listing search itself is 100% reused, not
 * reimplemented.
 *
 * An unresolved or ineligible slug is a no-op here: SeoLandingPage.js
 * independently renders NotFoundPage in that case, so there's nothing to
 * fetch.
 */
export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const { seoCategories, eligiblePaths } = getState().seoPages || {};
  const combo = resolveSeoSlug(params?.seoSlug, seoCategories || undefined);
  if (!combo || !(eligiblePaths || []).includes(buildSeoCanonicalPath(combo))) {
    return Promise.resolve();
  }
  const seoSearchParams = buildSeoSearchParams(combo);
  const syntheticSearch = `?${new URLSearchParams(seoSearchParams).toString()}`;
  return searchPageLoadData(params, syntheticSearch, config)(dispatch, getState, sdk);
};
